import FormSectionContainer from "../../components/Form/FormSectionContainer";
import FormSectionTitle from "../../components/styled/FormSectionTitle";

import { useGetAllUserAsDropdown } from "../../utils/user.utils";

export default function AssignedPersonField({ watch, control, errors, setValue }) {
  const { data: workPersons, loading } = useGetAllUserAsDropdown(``);

  const fields = [
    {
      label: "Name",
      name: "assigned_person.name",
      type: "select",
      placeholder: "Select a name",
      col: { md: 4 },
      options: workPersons ?? []
    },
    {
      label: "Work Start",
      name: "assigned_person.assigned_date",
      type: "datetime",
      placeholder: "Select a date",
      col: { md: 4 }
    },
    {
      label: "Work End",
      name: "assigned_person.deadline",
      type: "datetime",
      placeholder: "Select a date",
      col: { md: 4 }
    }
  ];

  const isLoading = loading;

  return (
    <>
      <FormSectionContainer
        setValue={setValue}
        fields={fields}
        control={control}
        watch={watch}
        errors={errors}
        loading={isLoading}>
        <div className="col-12">
          <FormSectionTitle>Assigned Person Information</FormSectionTitle>
        </div>
      </FormSectionContainer>
    </>
  );
}
